import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {ConfigServiceProvider} from '../../../services/config/config.service.provider';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    ConfigServiceProvider
  ]
})
export class MainLayoutComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
